export const RestoreBlueIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 0 16 18">
    <path id="restore_from_trash_24dp_FILL1_wght400_GRAD0_opsz24" d="M167-827h2v-4.15l1.6,1.55L172-831l-4-4-4,4,1.4,1.4,1.6-1.55Zm-4,5a1.926,1.926,0,0,1-1.413-.588A1.926,1.926,0,0,1,161-824v-13h-1v-2h5v-1h6v1h5v2h-1v13a1.926,1.926,0,0,1-.587,1.412A1.926,1.926,0,0,1,173-822Z" transform="translate(-160 840)" fill="#22638d"/>
  </svg>
);